<template>
  <div>
    <h6>Financial data</h6>

    <transition-group name="list" tag="div">
      <ProjectBenefit
        class="panel benefit"
        v-for="(benefit, index) of project.projectBenefits"
        :key="'benefit-' + benefit.id"
        :benefit="benefit"
        :savingsTypeOptions="org.savingsTypes.map(type => ({
                value: type.id,
                text: type.name,
              }))"
        :benefitConfidenceLabel="organizationBenefitConfidenceLabel"
        :confidenceOptions="savingsConfidenceOptions"
        :yearOptions="years"
        :getCurrencySymbol="getCurrencySymbol"
        @remove="removeBenefit(index)"
        :projectMembers="projectMembers"
        @updated="updateBenefit"
      />
    </transition-group>

    <div class="plus-btn" @click="addBenefit()">
      <img src="~@/assets/icons/add.svg" />
      <span>Add new</span>
    </div>

    <h6 class="spaced">Comment</h6>
    <div class="panel">
      <material-input
        v-model="project.benefitsNotes"
        type="textarea"
        label="Enter comment"
        :required="false"
        name="EnterComment"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import MaterialInput from './MaterialInput.vue';
import fy_months from '../utils/fy_months';
import currSymbol from 'currency-symbol-map';
import { mapGetters } from 'vuex';
import ProjectBenefit from "@/components/ProjectBenefit";

export default {
  name: 'ProjectModal_Benefits',
  props: {
    project: Object,
  },
  components: {
    ProjectBenefit,
    'material-input': MaterialInput,
  },
  methods: {
    updateBenefit() {
      this.$emit('forceRefresh');
    },
    getCurrencySymbol() {
      return currSymbol(this.currencyCodeById(this.project.currencyId));
    },
    getYearOption(offset) {
      const target_year = new Date().getFullYear() + offset;
      const year = fy_months(this.$store.getters.org.fy_month, target_year)
        .year;

      return {
        value: target_year,
        text: year,
      };
    },
    addBenefit() {
      const template = Object.assign({}, this.benefit_schema);
      template.id = Math.random();
      this.project.projectBenefits.push(template);
    },
    removeBenefit(index) {
      this.project.projectBenefits = this.project.projectBenefits.filter(
        (b, ind) => ind !== index
      );
    },
    updateDate(benefit, key, date) {
      if (date) {
        const new_date = moment(date, [
          'DD MMM YYYY',
          'YYYY-MM-DD',
          'YYYY-MM-DDTHH:mm:ss:SSSZ',
        ]);
        const old_date = moment(benefit[key], [
          'DD MMM YYYY',
          'YYYY-MM-DD',
          'YYYY-MM-DDTHH:mm:ss:SSSZ',
        ]);

        if (new_date && old_date && !new_date.isSame(old_date, 'd')) {
          benefit[key] = new_date.toISOString();
        }
      } else {
        benefit[key] = null;
      }
    },
  },
  computed: {
    ...mapGetters(['currencyCodeById', 'org', 'firstConversionRate']),
    projectMembers(){
      return (this.project && this.project.projectMembers) ? this.project.projectMembers : []
    },
    year() {
      const date = new Date();
      return date.getFullYear();
    },
    years() {
      return [
        this.getYearOption(-2),
        this.getYearOption(-1),
        this.getYearOption(0),
        this.getYearOption(1),
        this.getYearOption(2),
        this.getYearOption(3),
        this.getYearOption(4),
        this.getYearOption(5),
      ];
    },
    benefit_schema() {
      return this.$store.getters.benefit_schema;
    },
    // savingsStateOptions(){
    //   const state = [
    //     { value: 'Forecasted', text: 'Forecasted' },
    //     { value: 'Pending Approval', text: 'Pending Approval' },
    //     { value: 'Realized', text: 'Realized' },
    //   ];
    //
    //   return state;
    // },
    savingsConfidenceOptions(){
      const confidenceMap = this.organizationBenefitConfidenceFields.reduce((obj, el) => {
        obj[el.confidence] = el.alias
        return obj
      }, {})
      const confidenceOptions = [
        { value: 'Low', text: confidenceMap['Low'] || 'Low' },
        { value: 'Medium', text: confidenceMap['Medium'] || 'Medium' },
        { value: 'High', text: confidenceMap['High'] || 'High' },
        { value: 'At Risk', text: confidenceMap['At Risk'] || 'At Risk' },
      ];

      return confidenceOptions;
    },
    organizationBenefitConfidenceLabel(){
      const app_user = this.$store.getters.app_user
      return  (app_user.organization && app_user.organization.organizationBenefitConfidenceLabel) ?
        app_user.organization.organizationBenefitConfidenceLabel.alias : null
    },
    organizationBenefitConfidenceFields(){
      const app_user = this.$store.getters.app_user
      return  (app_user.organization && app_user.organization.organizationBenefitConfidenceFields) ?
        app_user.organization.organizationBenefitConfidenceFields : []
    }
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.list-item {
  display: inline-block;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.4s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.panel {
  padding: 25px 35px 0px;
  margin-top: -8px;
  margin-bottom: 20px;

  .material-input {
    flex: 1;
  }
}

.plus-btn {
  width: 200px;
}
</style>
